const commentContainers = document.getElementsByClassName("comment-container");

for (const commentContainer of commentContainers) {
  const [_, section_id, block_id] = commentContainer.id.split("/");

  const message = document.getElementById(
    `comment/${section_id}/${block_id}/message`
  );

  commentContainer.addEventListener("mouseover", () => {
    if (message) {
      message.classList.add("show");
    }
  });

  commentContainer.addEventListener("mouseleave", () => {
    if (message) {
      if (message.classList.contains("show")) {
        message.classList.remove("show");
      }
    }
  });
}
